// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-change-button[data-v-0fd670fc]{display:inline-block;margin-bottom:15px;margin-top:15px}.role-change-button[data-v-0fd670fc]:hover{cursor:pointer;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
